import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import { MarketResponse } from "./market.model";

const ACTION_PREFIX = "[Market]";
export const MARKET_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
};

/**
 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
 */
@Injectable({
	providedIn: "root",
})
export class MarketAction {
	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getAll(): Action {
		return {
			type: MARKET_ACTION_TYPE.getAll,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getSuccess(markets: MarketResponse): ActionWithPayload {
		return {
			type: MARKET_ACTION_TYPE.getAllSuccess,
			payload: markets,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use startup context service from svc-config instead
	 */
	getFail(response: AppError): ActionWithPayload {
		return {
			type: MARKET_ACTION_TYPE.getAllFail,
			payload: response,
		};
	}
}
